<div *ngIf="canComment" class="ui relaxed stackable grid comments-section">

  <div class="row">
    <div class="seven wide column">

    </div>
  </div>

  <div class="three wide column header-column">
    <h2 class="ui inverted header">
      {{resourceName === 'claims' ? 'Messages' : 'Comments'}}
    </h2>
  </div>
  <div *ngIf="user" class="right floated thirteen wide column">
    <form class="ui form" (submit)="submitComment()">
      <div class="field">
        <div class="ui small input">
          <textarea rows="1" autocomplete="off" placeholder="Write a message..."
            type="text" [(ngModel)]="commentText" name="commentText"></textarea>
          <button type="submit" tabindex="0" class="right floated ui inverted primary button"
            [class.loading]="submitting" [class.disabled]="submitting || result || commentText.length < 3">
            Post {{ messageName }}
          </button>
        </div>
      </div>

    </form>
  </div>
  <div *ngIf="!user" class="sixteen wide column">
    <p>
      You must be logged in to comment.
      <a href="/login">Click here to log in</a>
    </p>
    <br>
  </div>
</div>

<div *ngIf="result && canComment" class="ui compact inverted segment comment-completion-message"
  [ngClass]="messageClass">
  <p>{{ result.message }}</p>
  <i class="times icon" (click)="dismissMessage()"></i>
</div>


<div class="messages-container" [class.section]="canComment">
  <div class="ui inverted relaxed divided list">
    <div *ngIf="user && comments.length === 0" class="item comment">
      <p align="center" class="muted" *ngIf="canComment">
        Be the first to leave a
        comment!
      </p>
      <p align="center" class="muted" *ngIf="!canComment">
        No comments
      </p>
    </div>
    <div class="item comment" *ngFor="let comment of comments; let idx = index">
      <div class="ui grid">
        <div class="three wide computer four wide tablet eight wide mobile column user-column">
          <a target="_blank" [href]="'https://osu.ppy.sh/users/' +  comment.user.osu_username">
            <h4 class="username ui header" [class.teal]="comment.user.id === ownerId">
              <app-user-label [user]="comment.user"></app-user-label>
            </h4>
          </a>
          <div class="user-role">
            <p *ngIf="comment.user.id === ownerId">Bounty
              Creator
            </p>
            <p *ngIf="comment.user.isMod">
              Site Moderator
            </p>
          </div>
          <div class="comment-date">
            {{ comment.createdHumanReadable }}
          </div>
        </div>
        <div class="thirteen wide computer twelve wide tablet eight wide mobile column comment-text-column">
          <h5 *ngIf="resourceName === 'claims' && idx === comments.length -1">
            Evidence submitted:
          </h5>
          <p [innerHTML]="comment.comment | comment"></p>
        </div>
      </div>
    </div>
  </div>
</div>
